// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_gY3ia","secondaryColumnCell":"secondary-column-cell_gY3ia","title":"title_jvuwb","item":"item_Ma8ly","button":"button_LDj1G"};